import type { RouterSlice } from 'app/app-state';
import { connect } from 'react-redux';
import Redirect from './redirect.js';

export const mapStateToProps = (state: RouterSlice) => ({
  to: state.router.result?.to,
  from: state.router.result?.from
});

export default connect(mapStateToProps)(Redirect);
